import {
  mobileNavItemsCollaborator,
  collaboratorSideBarConstants,
} from "shared/utils/constants";
import { routeConstant } from "shared/routes/routeConstant";
import DashboardWrapper from "../../dashboardCommon/dashboardWrapper";

interface Props {
  children: any;
}

function CollaboratorWrapper({ children }: Props) {
  const mainPages = [
    routeConstant.collaborator.projects.path,
    routeConstant.collaborator.archivedProjects.path,
    routeConstant.collaborator.notifications.path,
    routeConstant.collaborator.accountSetting.path,
    routeConstant.collaborator.contact.path,
    routeConstant.collaborator.documents.path,
  ];

  return (
    <DashboardWrapper
      sidebarArr={collaboratorSideBarConstants}
      mobileNavItems={mobileNavItemsCollaborator}
      mainPages={mainPages}
      userType="collaborator"
      showMobileNavConditionally={true}
    >
      {children}
    </DashboardWrapper>
  );
}

export default CollaboratorWrapper;
